<template>
  <div class="breadcrumb">
    <el-breadcrumb>
      <!-- 菜单-->
      <el-breadcrumb-item>{{ menu }}</el-breadcrumb-item>
      <!--  页面-->
      <el-breadcrumb-item>{{ page }}</el-breadcrumb-item>
      <!--  子页面-->
      <el-breadcrumb-item v-if="menu1">{{ menu1 }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: ["menu", "page", "menu1"],
};
</script>

<style scoped>
.breadcrumb {
  background-color: #f8f8f8;
  padding: 18px 20px;
  margin-bottom: 15px;
}
</style>